import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {
  ActionType,
  Audience,
  Breadcrumb,
  Campaign,
  CampaignProduct,
  CustomStepCategoryEnum,
  defaultThemeColor,
  DiscountSetting,
  Funnel,
  FunnelInputTypeEnum,
  FunnelStep,
  getCampaignProductImageUrl,
  getDiscountSettingFromStep,
  OfferIntents,
  OfferStages,
  OfferTypeLabels,
  OfferTypes,
  ResolveOfferIntents,
  Pager,
  StepButtonControlTypes,
  StepButtonDetails,
  StepButtons,
  StepButtonShapes,
  StepButtonsLayout,
  StepCategoryLabels,
  StepElementTypes,
  StepEmulationTypes,
  StepEmulatorDevices,
  StepLayout,
  StepMedia,
  StepResponseMedia,
  StepCategory,
  StepTemplateFolder,
  StepTextual,
  Style,
  transparent,
  User,
  VariantTypeEnum,
} from '../../_models';
import {
  AlertService,
  AudienceService,
  CampaignService,
  FunnelService,
  FunnelStepService,
  LoaderService,
  SideNavService,
  StepEmulatorService,
  StepTemplateService,
  StorageService,
  StyleService,
  UserService, WidgetService,
} from '../../_services';
import {forkJoin, Subscription} from 'rxjs';
import {
  addDataAttributes,
  capitalizeFirstLetter,
  externalButtonUsage,
  getOfferBuilderRoot,
  getOfferBuilderSection,
  getStepDescription,
  getTruncatedProductName,
  initializeForm,
  normalizeObject,
  OfferBuilderSection,
  OfferData,
  patchInputs,
  stepLayout,
} from '../step-util';
import {config} from '../../../config/config';
import {Location} from '@angular/common';
import {FormArray, FormBuilder, FormGroup} from '@angular/forms';
import {DomSanitizer} from '@angular/platform-browser';
import {NgxSmartModalService} from 'ngx-smart-modal';
import {StepFormComponent} from './step-form/step-form.component';
import {StepEmulatorComponent} from './step-emulator/step-emulator.component';
import {CrudSaveComponent} from '../../_directives';
import {takeUntil} from 'rxjs/operators';
import { RetentionOffer } from '../../offer-builder/retention/retention';

@Component({
  selector: 'app-step-builder',
  templateUrl: './step-builder.component.html',
  styleUrls: ['./step-builder.component.scss'],
})
export class StepBuilderComponent extends CrudSaveComponent implements OnInit, OnDestroy, AfterViewInit {
  activeDevice = StepEmulatorDevices.Mobile;
  stepLayout: StepLayout[] = [];
  stepTextual: StepTextual;
  stepMedia: StepMedia;
  isAdminView: boolean = false;
  currentSection: OfferBuilderSection = OfferBuilderSection.Retention;
  stepResponseMedia: StepResponseMedia;
  stepButtons: StepButtons;
  private subscriptions: Subscription[] = [];
  stepTitle: string = '';
  stepDescription: string = '';
  stepType: StepCategory;
  stepId: string | number = '';
  funnelId: string | number = '';
  funnelIdFromParams: string | number = '';
  stepIdFromParams: number = null;
  editTemplate: boolean;
  templateId: string = '';
  funnel: Funnel;
  offerType: OfferTypes;
  reactivatePath: number;
  offerIntent: OfferIntents = null;
  offerName: string;
  showResponseButton: boolean = true;
  isResponseScreen: boolean = false;
  isStepPreview: boolean = true;
  isStepSaving: boolean = false;
  isPreviewLoading: boolean = false;
  isGlobalTemplate: boolean = false;
  isNew: boolean = true;
  breadcrumbs: Breadcrumb[] = [];
  campaign: Campaign;
  selectedProduct: CampaignProduct = null;
  productPlaceholderUrl: string = '';
  themes: Style[] = [];
  theme: string = defaultThemeColor;
  useExternalButtons = false;
  user: User;
  stepEmulationTypes = StepEmulationTypes;
  enableFormErrors = false;
  folderDetails: StepTemplateFolder;
  isSurveyStep = false;
  isSingleStepOffer = false;
  showSaveMenu: boolean = false;
  isSideNavExpanded: boolean = false;
  discount: DiscountSetting;
  segmentId: number;
  segmentName: string;
  confirmationStepType: string;
  isPopupStep: boolean = false;
  isPublishing: boolean = false;
  offerTypes = OfferTypes;
  private randomProduct: CampaignProduct = null;
  segmentedSurveyMap: { [audienceId: number]: number } = {};
  retentionOffers: RetentionOffer[] = [];
  segments: Audience[] = [];
  showResetDefault: boolean = false;
  selectedAudienceId: number = null;

  @ViewChild(StepEmulatorComponent, { static: false }) stepEmulator: StepEmulatorComponent;
  @ViewChild(StepFormComponent, { static: false }) stepFormComponent: StepFormComponent;

  constructor(
    protected route: ActivatedRoute,
    protected location: Location,
    private stepService: StepTemplateService,
    private stepEmulatorService: StepEmulatorService,
    private funnelService: FunnelService,
    private funnelStepService: FunnelStepService,
    private sideNav: SideNavService,
    protected alertService: AlertService,
    protected router: Router,
    private loader: LoaderService,
    private campaignService: CampaignService,
    protected styleService: StyleService,
    protected userService: UserService,
    protected formBuilder: FormBuilder,
    public ngxSmartModalService: NgxSmartModalService,
    private sanitizer: DomSanitizer,
    protected storageService: StorageService,
    protected audienceService: AudienceService,
    protected widgetService: WidgetService
  ) {
    super(router, location, route, stepService, alertService);

    this.sideNav.getSideNavObs().subscribe((data) => {
      this.isSideNavExpanded = data.isSideNavExpanded;
    });

    if (window.innerWidth < 1930) {
      this.sideNav.setSideNavExpanded(false);
    }

    this.route.params.subscribe((params) => {
      this.stepType = parseInt(params['step_type']);
      this.offerType = parseInt(params['offer_type']);
      this.offerIntent = params['offer_intent'] ? parseInt(params['offer_intent']) : null;
      this.offerName = OfferTypeLabels[this.offerType];
      this.isAdminView = this.route.snapshot.data['isAdminView'];
      this.currentSection = this.route.snapshot.data['section'];
      if (this.offerType === OfferTypes.Downsell) {
        this.offerName = getOfferBuilderRoot(this.currentSection);
      }
      this.stepId = params['step_id'];
      this.funnelId = params['offer_id'];
      this.editTemplate = params['edit'] === 'true';
      this.templateId = params['template_id'];
      this.segmentId = parseInt(params['segment_id']);
      this.isNew = !this.stepId;
      this.confirmationStepType = params['confirmationStepType'];
      this.funnelIdFromParams = params['offer_id'];
      this.stepIdFromParams = params['step_id'];
      this.stepLayout = stepLayout[this.stepType] || [];
      if (params['device']) {
        this.activeDevice = params['device'];
      }
    });

    this.reactivatePath = this.storageService.get('reactivatePath') || null;

    if (!this.offerIntent) {
      this.offerIntent = this.storageService.get('offerIntent') || null;
    }

    document.body.classList.add('step-builder-active');
  }

  ngOnInit() {
    if (!this.confirmationStepType) {
      this.loader.show('white', null, 998);
      this.form = initializeForm(this.formBuilder, this.stepType, this.offerType, this.editTemplate, this.offerIntent);
    } else {
      this.loader.show('white', null, 998);
      this.form = initializeForm(
        this.formBuilder,
        this.stepType,
        this.offerType,
        this.editTemplate,
        this.offerIntent,
        +this.confirmationStepType as FunnelInputTypeEnum
      );
    }

    if (this.isReactivateOffer) {
      this.funnelId = this.reactivatePath;
    }

    this.useExternalButtons = externalButtonUsage(this.stepType);
    this.stepDescription = getStepDescription(this.stepType);
    this.campaign = this.campaignService.getCurrentCampaign();
    this.isPopupStep = +this.confirmationStepType === FunnelInputTypeEnum.Confirmation;
    this.setProduct();
    this.getStyles();
    super.ngOnInit();

    this.userService.getCurrent().subscribe((user: User) => {
      this.user = user;
    });

    const textualSubscription = this.stepEmulatorService.stepTextual$.subscribe((data) => {
      this.stepTextual = data;
    });
    this.addSubscription(textualSubscription);

    const stepMediaSubscription = this.stepEmulatorService.stepMedia$.subscribe((data) => {
      this.stepMedia = data;
    });
    this.addSubscription(stepMediaSubscription);

    const responseMediaSubscription = this.stepEmulatorService.stepResponseMedia$.subscribe((data) => {
      this.stepResponseMedia = data;
    });
    this.addSubscription(responseMediaSubscription);

    const buttonsSubscription = this.stepEmulatorService.stepButtons$.subscribe((data) => {
      this.stepButtons = data;
    });
    this.addSubscription(buttonsSubscription);

    const responseScreenSubscription = this.stepEmulatorService.responseScreenState$.subscribe((isResponseScreen) => {
      this.isStepPreview = !isResponseScreen;
      this.isResponseScreen = isResponseScreen;
    });
    this.addSubscription(responseScreenSubscription);

    this.isSurveyStep = this.offerType === OfferTypes.Survey;
    this.isSingleStepOffer = this.offerType === OfferTypes.SingleStep;

    if (this.isEnterTroubleshooterStep) {
      this.isStepPreview = false;
      this.isResponseScreen = true;
    }

    if (this.isSingleStepOffer && this.stepType === CustomStepCategoryEnum.OfferDetails) {
      // remove last element from the layout
      this.stepLayout = this.stepLayout.filter((layout) => layout.type !== StepElementTypes.ResponseScreen);
    }

    // Modify button layout for single step offers
    if (this.isSingleStepOffer) {
      this.stepLayout.forEach((layoutItem) => {
        if (layoutItem.type === StepElementTypes.Buttons) {
          if (layoutItem.layout) {
            const buttonLayout = layoutItem.layout as StepButtonsLayout;
            buttonLayout.rejectTitle = null;
            buttonLayout.rejectDisabled = true;
          }
        }
      });
    }

    if (this.isSurveyStep && this.offerIntent) {
      this.fetchRetentionOffers();
    }

    if (this.templateId) {
      this.fetchTemplate();
    }

    if (this.segmentId) {
      this.fetchSegment();
    }

    this.generateBreadcrumbs();
    if (this.isSurveyStep && this.isAdmin) {
      this.stepTitle = this.getTitleForStepType(this.stepType, this.isNew);
    } else {
      this.stepTitle = null;
    }

    if (this.confirmationStepType) {
      this.fetchFunnel();
    } else if (this.stepId && this.funnelId) {
      this.isNew = false;
      this.funnelStepService.setFunnelId(this.funnelId);
      this.fetchFunnel();
      this.fetchOfferStep();
    } else if (this.funnelId) {
      this.fetchFunnel();
      this.funnelStepService.setFunnelId(this.funnelId);
    } else if (this.stepId) {
      this.isNew = false;
      this.fetchStep();
    }
  }

  fetchRetentionOffers(): void {
    // Resolve paths/segments are account-level (campaign-null), so they are fetched by account, not campaign
    const isResolve = ResolveOfferIntents.includes(this.offerIntent);
    this.funnelService
      .listRetentionOffers(
        isResolve ? null : this.campaign.id, this.offerIntent,
        [OfferTypes.Downsell, OfferTypes.Survey], false, this.user.account.id)
      .subscribe(
        (response) => {
          const results = response.results || [];

          // Map audienceId → offerId for survey offers that have a segment (audience)
          this.segmentedSurveyMap = results
            .filter((offer: RetentionOffer) => offer.offer_type === OfferTypes.Survey && offer.audience !== null)
            .reduce((acc: { [audienceId: number]: number }, offer: RetentionOffer) => {
              acc[offer.audience.id] = offer.id;
              return acc;
            }, {});

          // All retention offers passed to the survey options component
          this.retentionOffers = results.filter((offer: RetentionOffer) => offer.offer_type === OfferTypes.Downsell);

          // Segments are retention offers tied to an audience — extract name/id for the dropdown
          this.segments = results
            .filter((offer: RetentionOffer) => offer.offer_type === OfferTypes.Downsell && offer.audience !== null)
            .map((offer: RetentionOffer) => ({ name: offer.audience.name, id: offer.audience.id }));
        },
        (error) => {
          this.handleError(error);
        }
      );
  }

  ngAfterViewInit() {
    if (this.isNew && !this.templateId) {
      setTimeout(() => {
        this.loader.hide();
        this.stepEmulatorService.hideAllElements();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 3000);
    } else {
      this.loader.loader$.subscribe((state) => {
        if (!state) {
          this.stepEmulatorService.hideAllElements();
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      });
    }
  }

  generateBreadcrumbs() {
    const prefix = this.isAdmin ? ['admin'] : [];
    const offerIntentLabel = this.funnel ? OfferStages[this.funnel.offer_intent] : null;

    if (this.confirmationStepType) {
      this.breadcrumbs = [
        {
          label: capitalizeFirstLetter(getOfferBuilderRoot(this.currentSection)),
          url: [getOfferBuilderRoot(this.currentSection)],
        },
        {
          label: `${offerIntentLabel} Stage Settings`,
          url: [getOfferBuilderRoot(this.currentSection), this.funnelId, 'intent', this.offerIntent, 'settings'],
        },
      ];
    } else if (this.offerType === OfferTypes.Survey) {
      this.breadcrumbs = [
        {
          label: this.isAdmin ? capitalizeFirstLetter(this.offerName) : capitalizeFirstLetter(this.surveyBackTarget),
          url: [...prefix, this.isAdmin ? 'survey' : this.surveyBackTarget],
        },
        {
          label: `${this.isNew ? 'Create' : 'Edit'} Survey`,
        },
      ];
    } else if (this.segmentId && this.segmentName) {
      this.breadcrumbs = [
        {
          label: capitalizeFirstLetter(this.offerName),
          url: [this.offerName],
        },
        {
          label: 'Segments',
          url: [this.offerName, 'stage', this.funnelId, 'segment'],
        },
        {
          label: this.segmentName,
          url: [this.offerName, 'stage', this.funnelId, 'segment', this.segmentId],
        },
        ...(this.editTemplate
          ? [
              {
                label: this.templateId ? 'Edit Template' : 'Create A Template',
                url: [
                  this.offerName,
                  'stage',
                  this.funnelId,
                  'segment',
                  this.segmentId,
                  'category',
                  this.offerType,
                  'template',
                  this.stepType,
                ],
              },
            ]
          : [{ label: this.stepId ? 'Edit Offer' : 'Create An Offer' }]),
      ];
    } else if (this.isSingleStepOffer) {
      this.breadcrumbs = [
        {
          label: capitalizeFirstLetter(this.offerName),
          url: [...prefix, this.offerName],
        },
        {
          label: `${this.isNew ? 'Create' : 'Edit'} Step`,
        },
      ];
    } else if (this.reactivatePath) {
      this.breadcrumbs = [
        {
          label: capitalizeFirstLetter(this.offerName),
          url: [...prefix, this.offerName],
        },
        {
          label: this.offerIntent && OfferStages[this.offerIntent],
          url: [...prefix, this.offerName, 'stage', this.funnelIdFromParams],
        },
        ...(this.editTemplate
          ? [
              {
                label: this.templateId ? 'Edit Template' : 'Create A Template',
                url: [
                  ...prefix,
                  this.offerName,
                  'stage',
                  this.funnelIdFromParams,
                  'category',
                  this.offerType,
                  'template',
                  this.stepType,
                ],
              },
            ]
          : [{ label: this.stepId ? 'Edit Offer' : 'Create An Offer' }]),
      ];
    } else {
      this.breadcrumbs = [
        {
          label: capitalizeFirstLetter(this.offerName),
          url: [...prefix, this.offerName],
        },
        {
          label: this.funnel && OfferStages[this.funnel.offer_intent],
          url: [...prefix, this.offerName, 'stage', this.funnelId],
        },
        ...(this.editTemplate
          ? [
              {
                label: this.templateId ? 'Edit Template' : 'Create A Template',
                url: [
                  ...prefix,
                  this.offerName,
                  'stage',
                  this.funnelId,
                  'category',
                  this.offerType,
                  'template',
                  this.stepType,
                ],
              },
            ]
          : [{ label: this.stepId ? 'Edit Offer' : 'Create An Offer' }]),
      ];
    }
  }

  getStyles() {
    this.styleService.list({ page: 1, page_size: config.maxPageSize }).subscribe(
      (data: Pager) => {
        this.themes = data.results;
        if (this.themes.length && this.campaign.styles.length) {
          const selectedTheme = this.themes.find((theme) => theme.id === this.campaign.styles[0]);
          if (selectedTheme && selectedTheme.variables && selectedTheme.variables.theme_color) {
            this.theme = selectedTheme.variables.theme_color;
          }
        }
      },
      (err) => {
        this.alertService.error(err.message);
      }
    );
  }

  scroll() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  fetchFunnel() {
    this.funnelService.get(this.funnelId).subscribe(
      (response: Funnel) => {
        this.funnel = response;

        if (!this.offerIntent) {
          this.offerIntent = response.offer_intent;
        }

        this.generateBreadcrumbs();
        this.stepTitle = this.getTitleForStepType(this.stepType, this.isNew, this.confirmationStepType);

        if (this.confirmationStepType) {
          if (response && response.steps && response.steps.length > 0) {
            let data;
            // Find confirmation step (category: 28, type: 28)
            if (
              +this.stepType === +FunnelInputTypeEnum.Confirmation &&
              +this.confirmationStepType === +FunnelInputTypeEnum.Confirmation
            ) {
              data = response.steps.find(
                (step) =>
                  step.category === FunnelInputTypeEnum.Confirmation && step.type === FunnelInputTypeEnum.Confirmation
              );
            }

            // Find response step (category: 28, type: 10)
            if (
              +this.stepType === +FunnelInputTypeEnum.Confirmation &&
              +this.confirmationStepType === +FunnelInputTypeEnum.InputActionStatus
            ) {
              data = response.steps.find(
                (step) =>
                  step.category === FunnelInputTypeEnum.Confirmation &&
                  step.type === FunnelInputTypeEnum.InputActionStatus
              );
            }

            // Find generic response step (category: 10, type: 10) by id
            if (
              +this.stepType === +FunnelInputTypeEnum.InputActionStatus &&
              +this.confirmationStepType === +FunnelInputTypeEnum.InputActionStatus
            ) {
              data = response.steps.find((step) => +step.id === +this.stepId);
            }

            const step_data = {
              ...data,
              offer_type: this.offerType,
            };

            if (data) {
              patchInputs(
                this.form,
                this.formBuilder,
                step_data,
                this.useExternalButtons,
                this.stepMedia,
                this.stepResponseMedia,
                this.sanitizer,
                this.stepEmulatorService
              );
            }

            this.loader.hide();
          }
        }
      },
      (error) => {
        this.handleError(error);
      }
    );
  }

  fetchTemplate() {
    this.loader.show('white', null, 998);

    this.stepService.get(this.templateId).subscribe(
      (response: FunnelStep) => {
        if (response) {
          const data = !this.editTemplate && this.templateId ? normalizeObject(response) : response;
          patchInputs(
            this.form,
            this.formBuilder,
            data,
            this.useExternalButtons,
            this.stepMedia,
            this.stepResponseMedia,
            this.sanitizer,
            this.stepEmulatorService
          );
          this.isGlobalTemplate = data.is_global;
          this.discount = getDiscountSettingFromStep(response);
        }
        this.loader.hide();
      },
      (error) => {
        this.handleError(error);
        this.loader.hide();
      }
    );
  }

  fetchSegment() {
    this.audienceService.get(this.segmentId).subscribe(
      (audience: Audience) => {
        this.segmentName = audience.name;
        this.generateBreadcrumbs();
      },
      (error) => {
        this.handleError(error);
      }
    );
  }

  fetchOfferStep() {
    this.loader.show('white', null, 998);

    // Offer Step Fetching
    this.funnelStepService.get(this.stepId).subscribe(
      (data: FunnelStep) => {
        const step_data = {
          ...data,
          offer_type: this.offerType,
        };
        if (data) {
          patchInputs(
            this.form,
            this.formBuilder,
            step_data,
            this.useExternalButtons,
            this.stepMedia,
            this.stepResponseMedia,
            this.sanitizer,
            this.stepEmulatorService,
            this.offerType
          );
          this.discount = getDiscountSettingFromStep(data);
        }
        this.loader.hide();
      },
      (error) => {
        this.handleError(error);
        this.loader.hide();
      }
    );
  }

  fetchStep() {
    this.loader.show('white', null, 998);

    //Survey Step Fetching
    this.stepService.get(this.stepId).subscribe(
      (data: FunnelStep) => {
        const step_data = {
          ...data,
          offer_type: this.offerType,
        };

        if (data) {
          patchInputs(
            this.form,
            this.formBuilder,
            step_data,
            this.useExternalButtons,
            this.stepMedia,
            this.stepResponseMedia,
            this.sanitizer,
            this.stepEmulatorService
          );
          this.discount = getDiscountSettingFromStep(data);
        }
        this.loader.hide();
      },
      (error) => {
        this.handleError(error);
        this.loader.hide();
      }
    );
  }

  updateProductImageUrl() {
    this.productPlaceholderUrl = this.selectedProduct.id ? getCampaignProductImageUrl(this.selectedProduct) : null;
  }

  loadPreview() {
    if (this.form.invalid) {
      this.enableFormErrors = true;
      setTimeout(() => this.scrollToError(), 50);
      this.showSaveMenu = false;
    } else {
      this.enableFormErrors = false;
      this.isPreviewLoading = true;
      const body = this.form.value;
      this.manipulateHTMLContent(body);
      const productId = (this.emulatorProduct && this.emulatorProduct.id) || null;
      body.offer_type = this.offerType;
      body.offer_intent = this.offerIntent;
      this.funnelService.previewStep(this.campaign.id, body, productId).subscribe(
        (data) => {
          window.open(data.toString(), '_blank');
          this.isPreviewLoading = false;
          this.showSaveMenu = false;
        },
        (error) => {
          this.handleError(error);
          this.isPreviewLoading = false;
          this.showSaveMenu = false;
        }
      );
    }
  }

  setProduct() {
    const product = this.storageService.get('selectedStepProduct');
    const requiresVariant = this.stepType === CustomStepCategoryEnum.ChangeVariant;

    if (product && product.id && (!requiresVariant || product.product.variant_type !== VariantTypeEnum.None)) {
      setTimeout(() => {
        this.onProductSelected(product);
      }, 1000);
    } else {
      if (!this.randomProduct) {
        this.getRandomPreviewProduct(requiresVariant);
      }
    }
  }

  get emulatorProduct() {
    return this.selectedProduct || this.randomProduct;
  }

  protected getRandomPreviewProduct(requiresVariant: boolean) {
    if (this.campaign) {
      this.campaignService
        .getRandomPreviewProduct(this.campaign.id, requiresVariant)
        .pipe(takeUntil(this._destroy$))
        .subscribe({
          next: (response: any) => {
            this.randomProduct = response;
            this.productPlaceholderUrl = getCampaignProductImageUrl(this.randomProduct);
          },
          error: (error) => {
            this.randomProduct = null;
            this.productPlaceholderUrl = '';
            if (error.status !== 404) {
              this.handleError(error);
            }
          },
        });
    }
  }

  onSubmit(navigateAfterSave: boolean = false) {
    if (this.editTemplate) {
      this.saveTemplate(navigateAfterSave);
    } else if (this.confirmationStepType) {
      this.saveConfig(navigateAfterSave);
    } else {
      if (this.form.invalid) {
        this.enableFormErrors = true;
        setTimeout(() => this.scrollToError(), 50);
        return;
      }

      this.enableFormErrors = false;
      switch (this.stepType) {
        case CustomStepCategoryEnum.CancelSubSurvey:
        case CustomStepCategoryEnum.CancelOrderSurvey:
        case CustomStepCategoryEnum.CancelTrialSurvey:
        case CustomStepCategoryEnum.Survey:
        case CustomStepCategoryEnum.ReturnSurvey:
        case CustomStepCategoryEnum.ResolveSurvey:
          if (this.isAdmin) {
            this.saveSurveyStep(navigateAfterSave);
          } else {
            this.saveOfferStep(navigateAfterSave);
          }
          break;
        default:
          this.saveOfferStep(navigateAfterSave);
          break;
      }
    }
  }

  publishSurvey() {
    if (this.funnel && this.funnel.id) {
      this.isPublishing = true;
      this.funnelService.publish(this.funnel.id).subscribe(
        () => {
          this.isPublishing = false;
          this.funnel.is_modified = false;
          this.alertService.success('Changes are being published.');
        },
        (error) => {
          this.isPublishing = false;
          this.alertService.error('Failed to publish survey.');
        }
      );
    }
  }

  saveSurveyStep(navigateAfterSave: boolean = false) {
    this.isStepSaving = true;
    let body;
    body = this.form.value;

    this.manipulateHTMLContent(body);

    const handleSuccess = () => {
      this.alertService.success('Changes saved. Publish to make them live.', true);
      this.canDeactivateService.setFormDirty(false);

      this.isStepSaving = false;
      if (navigateAfterSave) {
        setTimeout(() => {
          this.navigate([...(this.isAdmin ? ['admin'] : []), 'survey']);
        }, 2000);
      }
    };

    const handleError = (err: any) => {
      this.isStepSaving = false;

      if (err.status === 400) {
        this.alertService.error(err.error.name);
      } else {
        this.alertService.error(err.message);
      }
    };

    if (this.isNew) {
      /* Create Survey Step */
      this.stepService.create(body).subscribe((step: FunnelStep) => {
        // Save the survey step id in local storage
        this.storageService.set(OfferTypeLabels[this.offerType], step.id);
        handleSuccess();
      }, handleError);
    } else {
      /* Save Survey Step */
      this.stepService.update(this.stepId, body).subscribe(handleSuccess, handleError);
    }
  }

  processDiscountWithRefund(body: FunnelStep) {
    if (body && body.inputs && body.inputs.length > 0) {
      // Find the accept input (input with has_response_step = true)
      const acceptInput = body.inputs.find((input) => input.has_response_step === true);

      if (acceptInput && acceptInput.actions && acceptInput.actions.length > 0) {
        const discountAction = acceptInput.actions.find((action) => action.resourcetype === ActionType.Discount);
        const refundActionIndex = acceptInput.actions.findIndex((action) => action.resourcetype === ActionType.Refund);

        if (discountAction) {
          if (discountAction.isDiscountWithRefund) {
            // isDiscountWithRefund is true: apply discount settings to refund action or create one
            if (refundActionIndex > -1) {
              // Refund action exists: apply all settings from discount action except id
              const refundAction = acceptInput.actions[refundActionIndex];
              const refundId = refundAction.id;
              Object.keys(discountAction).forEach((key) => {
                if (key !== 'id' && key !== 'resourcetype') {
                  refundAction[key] = discountAction[key];
                }
              });
              refundAction.id = refundId;
              refundAction.resourcetype = ActionType.Refund;
            } else {
              // Refund action does not exist: copy discount action, change resourcetype to Refund with null id
              const newRefundAction = { ...discountAction };
              newRefundAction.id = null;
              newRefundAction.resourcetype = ActionType.Refund;
              acceptInput.actions.push(newRefundAction);
            }
          } else {
            // isDiscountWithRefund is false: remove refund action if it exists
            if (refundActionIndex > -1) {
              acceptInput.actions.splice(refundActionIndex, 1);
            }
          }
        }
      }
    }
  }

  saveOfferStep(navigateAfterSave: boolean = false) {
    this.isStepSaving = true;
    let body = this.form.value;

    if (body.category === CustomStepCategoryEnum.DiscountFutureOrder && this.isEligibleForDiscountWithRefund()) {
      this.processDiscountWithRefund(body);
    }

    body = {
      ...body,
      response_data: {
        ...body.response_data,
        name: `${body.name} response`,
      },
    };

    this.manipulateHTMLContent(body);

    const handleSuccess = () => {
      const successMessage = this.isSingleStepOffer ? 'Changes saved.' : 'Changes saved. Publish to make it live.';
      this.alertService.success(successMessage, true);

      this.canDeactivateService.setFormDirty(false);

      if (this.funnel) {
        this.funnel.is_modified = true;
      }

      this.isStepSaving = false;
      if (navigateAfterSave) {
        setTimeout(() => {
          const prefix = this.isAdmin ? ['admin'] : [];
          if (this.isSingleStepOffer) {
            this.navigate([this.offerName]);
          } else if (this.isSurveyStep) {
            this.navigate([...prefix, this.surveyBackTarget]);
          } else if (this.segmentId) {
            this.navigate([...prefix, this.offerName, 'stage', this.funnelIdFromParams, 'segment', this.segmentId]);
          } else {
            this.navigate([...prefix, this.offerName, 'stage', this.funnelIdFromParams]);
          }
        }, 2000);
      }
    };

    const handleError = (err: any) => {
      this.isStepSaving = false;

      if (err.status === 400) {
        this.alertService.error(err.error.name || err.error[0]);
      } else {
        this.alertService.error(err.message);
      }
    };

    if (this.isNew) {
      if (this.isSingleStepOffer) {
        /* Creating a new Offer/Funnel with the first offer step */
        const data = {
          ...OfferData,
          name: body.name,
          offer_type: this.offerType,
          offer_intent: body.offer_intent,
          steps: [body],
        };

        this.funnelService.create(data).subscribe((data: Funnel) => {
          this.funnelId = data.id;
          this.funnel = data;
          this.funnelStepService.setFunnelId(this.funnelId);
          body.name = data.name;
          handleSuccess();
        }, handleError);
      } else {
        if (this.funnel.offer_steps && this.funnel.offer_steps.length > 0) {
          const lastStepIndex = this.funnel.offer_steps.length - 1;
          if (
            this.funnel.offer_steps[lastStepIndex].inputs &&
            this.funnel.offer_steps[lastStepIndex].inputs.length > 0
          ) {
            const parentInputIds = [];
            this.funnel.offer_steps[lastStepIndex].inputs.forEach((input) => {
              if (!input.has_response_step) {
                parentInputIds.push(input.id);
              }
            });
            if (parentInputIds.length > 0) {
              body = {
                ...body,
                parent_inputs: parentInputIds,
              };
            }
          }
        }

        /* Create New Offer Step */
        this.funnelStepService.create(body).subscribe(handleSuccess, handleError);
      }
    } else {
      /* Update Offer Step */
      if (this.isSurveyStep && !this.isAdmin) {
        body = {
          ...body,
          response_data: null,
        };
      }
      this.funnelStepService.update(this.stepId, body).subscribe(handleSuccess, handleError);
    }
  }

  saveConfig(navigateAfterSave: boolean = false) {
    this.isStepSaving = true;
    let body = this.form.value;
    const stepPatch: any = { id: body.id, name: body.name };
    const labelCtrl = this.form.get('label');
    const contentCtrl = this.form.get('content');

    if (labelCtrl && labelCtrl.dirty) {
      const labelValue = labelCtrl.value;

      if (+this.confirmationStepType === FunnelInputTypeEnum.InputActionStatus) {
        // Wrap label content with response-heading class if it doesn't already have it
        if (labelValue && !labelValue.includes('response-heading')) {
          stepPatch.label = `<div class="response-heading">${labelValue}</div>`;
        } else {
          stepPatch.label = labelValue;
        }
      } else {
        stepPatch.label = labelValue;
      }
    }

    if (contentCtrl && contentCtrl.dirty) {
      const contentValue = contentCtrl.value;

      if (+this.confirmationStepType === FunnelInputTypeEnum.InputActionStatus) {
        // Wrap content with response-content class if it doesn't already have it
        if (contentValue && !contentValue.includes('response-content')) {
          stepPatch.content = `<div class="response-content">${contentValue}</div>`;
        } else {
          stepPatch.content = contentValue;
        }
      } else {
        stepPatch.content = contentValue;
      }
    }

    const inputsFormArray = this.form.get('inputs') as FormArray;
    const dirtyInputPatches: any[] = [];

    if (inputsFormArray && inputsFormArray.controls) {
      inputsFormArray.controls
        .filter((inputControl: FormGroup) => inputControl && inputControl.get('id'))
        .forEach((inputControl: FormGroup) => {
          dirtyInputPatches.push({
            id: inputControl.get('id').value,
            type: inputControl.get('type').value,
            label: inputControl.get('label') ? inputControl.get('label').value : null,
            actions: inputControl.get('actions') ? inputControl.get('actions').value : null,
          });
        });
    }

    if (dirtyInputPatches.length > 0) {
      stepPatch.inputs = dirtyInputPatches;
    }

    if (
      stepPatch.label !== undefined ||
      stepPatch.content !== undefined ||
      (stepPatch.inputs && stepPatch.inputs.length > 0)
    ) {
      let message = 'Confirmation Popup updated, Publish to make it live.';
      if (+this.confirmationStepType === FunnelInputTypeEnum.InputActionStatus) {
        message =
          +this.stepType === FunnelInputTypeEnum.Confirmation
            ? 'Cancellation Response updated, Publish to make it live.'
            : 'Response updated, Publish to make it live.';
      }
      this.funnelStepService.setFunnelId(this.funnelId);
      this.funnelStepService.patch(body.id, stepPatch).subscribe(
        (offer: Funnel) => {
          this.alertService.success(message, true);
          this.funnel = offer;
          this.isStepSaving = false;
          this.canDeactivateService.setFormDirty(false);
          if (navigateAfterSave) {
            setTimeout(() => {
              this.router.navigate([
                getOfferBuilderRoot(this.currentSection),
                this.funnelIdFromParams,
                'intent',
                this.offerIntent,
                'settings',
              ]);
            }, 2000);
          }
        },
        (error) => {
          this.handleError(error);
          this.isStepSaving = false;
        }
      );
    }
  }

  closeStep() {
    const prefix = this.isAdmin ? ['admin'] : [];
    if (this.confirmationStepType) {
      this.router.navigate([getOfferBuilderRoot(this.currentSection), this.funnelIdFromParams, 'intent', this.offerIntent, 'settings']);
    } else if (this.isSingleStepOffer) {
      this.navigate([...prefix, this.offerName]);
    } else if (this.isSurveyStep) {
      this.navigate([...prefix, this.isAdmin ? 'survey' : this.surveyBackTarget]);
    } else if (this.templateId) {
      this.navigate([
        ...prefix,
        this.offerName,
        'stage',
        this.funnelIdFromParams,
        'category',
        this.offerType,
        'template',
        this.stepType,
      ]);
    } else {
      this.navigate([...prefix, this.offerName, 'stage', this.funnelIdFromParams]);
    }
  }

  toggleSaveMenu() {
    this.showSaveMenu = !this.showSaveMenu;
  }

  closeOutside() {
    this.showSaveMenu = false;
  }

  saveTemplate(navigateAfterSave: boolean = false) {
    if (this.form.invalid) {
      this.enableFormErrors = true;
      setTimeout(() => this.scrollToError(), 50);
      return;
    }

    this.isStepSaving = true;
    this.enableFormErrors = false;

    let body;
    body = {
      ...this.form.value,
      is_template: true,
      is_global: this.isGlobalTemplate,
    };
    if (this.funnelId) {
      body = {
        ...body,
        response_data: {
          ...body.response_data,
          name: `${body.name} response`,
        },
      };
    }

    this.manipulateHTMLContent(body);
    const handleResponse = (response: FunnelStep) => {
      this.alertService.success('Saved Successfully.', true);
      this.canDeactivateService.setFormDirty(false);
      this.isStepSaving = false;

      if (navigateAfterSave) {
        this.navigateFromTemplate();
      }
    };

    const handleError = (err: any) => {
      this.isStepSaving = false;

      if (err.status === 400) {
        this.alertService.error(err.error.name);
      } else {
        this.alertService.error(err.message);
      }
    };

    if (this.editTemplate && !this.templateId) {
      // Create Template
      this.stepService.create(body).subscribe(handleResponse, handleError);
    } else {
      // Update Template
      this.stepService.update(this.templateId, body).subscribe(handleResponse, handleError);
    }
  }

  navigateFromTemplate() {
    const baseRoute = this.funnelId
      ? [this.offerName, 'stage', this.funnelIdFromParams, 'category', this.offerType, 'template', this.stepType]
      : [this.offerName, 'category', this.offerType, 'template', this.stepType];

    if (this.isGlobalTemplate) {
      baseRoute.push('global');
    }

    this.router.navigate(baseRoute);
  }

  manipulateHTMLContent(body: FunnelStep) {
    if (this.useExternalButtons) {
      body.button_styles.confirm = this.addButtonStyles(this.stepButtons.confirmButton);
      if (
        this.stepType === CustomStepCategoryEnum.AdjustShippingFrequency ||
        this.stepType === CustomStepCategoryEnum.AdjustTrialFrequency ||
        this.stepType === CustomStepCategoryEnum.PauseSurvey
      ) {
        if (this.isSingleStepOffer) {
          body.inputs[body.inputs.length - 1].button_styles = null;
        } else {
          body.inputs[body.inputs.length - 1].button_styles = this.addButtonStyles(this.stepButtons.rejectButton);
        }
      }
    } else {
      body.inputs[0].label = addDataAttributes(body.inputs[0].label);
      body.inputs[0].button_styles = this.addButtonStyles(this.stepButtons.confirmButton);

      if (body.inputs.length > 1) {
        body.inputs[1].label = addDataAttributes(body.inputs[1].label);
        body.inputs[1].button_styles = this.addButtonStyles(this.stepButtons.rejectButton);
      }
    }

    body.banner = addDataAttributes(body.banner);
    body.label = addDataAttributes(body.label);
    body.content = addDataAttributes(body.content);

    if (body.response_data) {
      body.response_data = {
        ...body.response_data,
        label: addDataAttributes(body.response_data.label),
        content: addDataAttributes(body.response_data.content),
      };
    }
  }

  addButtonStyles(details: StepButtonDetails) {
    let styleString;
    const outlineShapes = [StepButtonShapes.FlatOutline, StepButtonShapes.ModernOutline, StepButtonShapes.PillOutline];
    const isOutlineShape = outlineShapes.includes(+details.style);
    const isTextOnly = +details.style === StepButtonShapes.TextOnly;
    const themeString = 'var(--theme_color)',
      color =
        +details.type === StepButtonControlTypes.Theme && (isOutlineShape || isTextOnly)
          ? themeString
          : details.fontColor,
      background = +details.type === StepButtonControlTypes.Theme ? themeString : details.backgroundColor,
      borderColor = +details.type === StepButtonControlTypes.Theme ? themeString : details.borderColor,
      borderRadius = details.borderRadius,
      borderWidth = details.borderWidth || '1px';

    switch (details.style) {
      case StepButtonShapes.Flat:
      case StepButtonShapes.Modern:
      case StepButtonShapes.Pill:
        styleString =
          `color: ${color}; background-color: ${background}; border-color: ${borderColor}; border-width: ${borderWidth}; border-radius: ${borderRadius}; min-height: 72px; padding: 16px 10px;`.trim();
        break;
      case StepButtonShapes.FlatOutline:
      case StepButtonShapes.ModernOutline:
      case StepButtonShapes.PillOutline:
        styleString =
          `color: ${color}; background-color: ${transparent}; border-color: ${borderColor}; border-width: ${borderWidth}; border-radius: ${borderRadius}; min-height: 72px; padding: 16px 10px;`.trim();
        break;
      case StepButtonShapes.TextOnly:
        styleString =
          `color: ${color}; background-color: ${transparent}; border-color: ${transparent}; border-width: 0;`.trim();
        break;
    }

    if (this.useExternalButtons) {
      return {
        label: addDataAttributes(details.content),
        style: styleString,
        style_type: details.style,
        control_type: details.type,
      };
    }

    return {
      style: styleString,
      style_type: details.style,
      control_type: details.type,
    };
  }

  openMobile() {
    this.activeDevice = StepEmulatorDevices.Mobile;
  }

  openTablet() {
    this.activeDevice = StepEmulatorDevices.Tablet;
  }

  openDesktop() {
    this.activeDevice = StepEmulatorDevices.Desktop;
  }

  changePreview(config: StepEmulationTypes) {
    if (config === StepEmulationTypes.Preview) {
      this.isStepPreview = true;
      this.isResponseScreen = false;
    } else if (config === StepEmulationTypes.Response) {
      this.isStepPreview = false;
      this.isResponseScreen = true;
    }
  }

  openProductSelector() {
    this.ngxSmartModalService.getModal('selectProductsDialog').open();
  }

  onSegmentChange(event: Event): void {
    const selectedId = +(event.target as HTMLSelectElement).value;
    const offerId = this.segmentedSurveyMap[selectedId] || null;

    this.loader.show('white', null, 998);

    if (offerId) {
      this.funnelService.get(offerId).subscribe(
        (response) => {
          this.handleSegmentResponse(selectedId, response);
        },
        (error) => {
          this.handleError(error);
        }
      );
    } else {
      const campaignId = this.campaign ? +this.campaign.id : null;
      this.funnelStepService.generateSurveySegment(this.stepIdFromParams, campaignId, selectedId).subscribe(
        (response) => {
          this.handleSegmentResponse(selectedId, response);
        },
        (error) => {
          this.handleError(error);
        }
      );
    }
  }

  private handleSegmentResponse(audienceId: number, response: Funnel): void {
    this.segmentedSurveyMap[audienceId] = +response.id;
    this.selectedAudienceId = audienceId;

    // Updating funnel & Step id for patching the API with new ids
    this.funnelId = +response.id;
    this.stepId = +response.first_step;

    // Re-initialize the form so stale control values from the previous segment are cleared
    this.form = initializeForm(this.formBuilder, this.stepType, this.offerType, this.editTemplate, this.offerIntent);

    let firstStep: FunnelStep = null;
    if (response.steps && response.steps.length > 0) {
      firstStep = response.steps.find((step) => step.id === response.first_step) || null;
    }

    if (firstStep) {
      const stepData = {
        ...firstStep,
        offer_type: this.offerType,
      };
      this.funnelStepService.setFunnelId(this.funnelId);
      patchInputs(
        this.form,
        this.formBuilder,
        stepData,
        this.useExternalButtons,
        this.stepMedia,
        this.stepResponseMedia,
        this.sanitizer,
        this.stepEmulatorService
      );
      this.showResetDefault = true;
      this.loader.hide();
    } else {
      this.loader.hide();
      this.handleError('Could not find the first step in the segment response.');
    }
  }

  resetToDefault() {
    const funnelIdToDelete = this.segmentedSurveyMap[this.selectedAudienceId];

    if (funnelIdToDelete) {
      // Remove the audience→funnel mapping so a fresh one can be generated on next selection
      delete this.segmentedSurveyMap[this.selectedAudienceId];

      this.loader.show('white', null, 998);

      this.funnelService.delete(funnelIdToDelete).subscribe(
        () => {
          this.showResetDefault = false;
          this.selectedAudienceId = null;

          this.form = initializeForm(
            this.formBuilder,
            this.stepType,
            this.offerType,
            this.editTemplate,
            this.offerIntent
          );

          // Restore the original funnel context from route params and re-patch the form
          this.funnelId = this.funnelIdFromParams
          this.stepId = this.stepIdFromParams
          this.funnelStepService.setFunnelId(this.funnelId);
          this.funnelStepService.get(this.stepId).subscribe(
            (data: FunnelStep) => {
              const stepData = {
                ...data,
                offer_type: this.offerType,
              };
              if (data) {
                patchInputs(
                  this.form,
                  this.formBuilder,
                  stepData,
                  this.useExternalButtons,
                  this.stepMedia,
                  this.stepResponseMedia,
                  this.sanitizer,
                  this.stepEmulatorService
                );
              }
              this.loader.hide();
            },
            (error) => {
              this.loader.hide();
              this.handleError(error);
            }
          );
        },
        (error) => {
          this.handleError(error);
        }
      );
    }
  }

  onProductSelected(product: CampaignProduct) {
    this.loader.show();
    forkJoin([
      this.widgetService.list({ campaign_product: product.id }),
      this.widgetService.list({ product: product.product.id }),
    ]).subscribe(
      (data: [Pager, Pager]) => {
        product.widgets = data[0].results;
        product.product.widgets = data[1].results;
        this.selectedProduct = product;
        this.storageService.set('selectedStepProduct', product);
        this.updateProductImageUrl();
        this.loader.hide();
      },
      (error) => {
        this.loader.hide();
        this.handleError(error);
      }
    );
    this.ngxSmartModalService.getModal('selectProductsDialog').close();
  }

  getTitleForStepType(stepType: StepCategory, isNew: boolean, confirmationStepType?: string): string {
    let title: string;

    if (confirmationStepType) {
      if (+confirmationStepType === +FunnelInputTypeEnum.Confirmation) {
        title = 'Cancellation Confirmation Pop-up';
      } else if (stepType === FunnelInputTypeEnum.Confirmation) {
        title = 'Cancellation Response';
      } else {
        title = 'Response';
      }
    } else if (stepType === FunnelInputTypeEnum.EnterTroubleshooter) {
      title = 'Troubleshooter';
    } else if (this.isSurveyStep) {
      title = `${OfferStages[this.offerIntent]} Survey`;
    } else if (this.isSingleStepOffer) {
      title = this.funnel.name;
    } else {
      title = StepCategoryLabels[stepType];
    }
    return title;
  }

  navigate(url: any[]) {
    this.router.navigate(url);
  }

  get isMobile() {
    return this.activeDevice === StepEmulatorDevices.Mobile;
  }

  get isTablet() {
    return this.activeDevice === StepEmulatorDevices.Tablet;
  }

  get isAdmin(): boolean {
    return this.isAdminView && this.user && this.user.is_staff;
  }

  get surveyBackTarget(): OfferBuilderSection {
    let target = OfferBuilderSection.Retention;
    if (!this.isAdmin) {
      target = getOfferBuilderSection(this.offerIntent);
    }
    return target;
  }

  get isReactivateOffer(): boolean {
    return (
      this.offerIntent === OfferIntents.CancelSubscription &&
      this.stepType === CustomStepCategoryEnum.ReActivateSubscriptionWithDiscount &&
      !!this.reactivatePath
    );
  }

  get isEnterTroubleshooterStep(): boolean {
    return this.stepType === FunnelInputTypeEnum.EnterTroubleshooter;
  }

  get isDesktop() {
    return this.activeDevice === StepEmulatorDevices.Desktop;
  }

  getProductName(): string {
    if (this.selectedProduct && this.selectedProduct.name) {
      return getTruncatedProductName(this.selectedProduct.name);
    } else if (this.randomProduct && this.randomProduct.name) {
      return getTruncatedProductName(this.randomProduct.name);
    }
  }

  addSubscription(subscription: Subscription): void {
    this.subscriptions.push(subscription);
  }

  scrollToError() {
    this.stepFormComponent.scrollToFirstErrorComponent();
  }

  navigateToTemplates() {
    setTimeout(() => {
      const baseRoute = ['steps', this.offerName];
      const route =
        this.isSurveyStep || this.isSingleStepOffer
          ? [...baseRoute, 'category', this.offerType, 'template', this.stepType]
          : [...baseRoute, this.funnelIdFromParams, 'category', this.offerType, 'template', this.stepType];

      this.router.navigate(route);
    }, 2000);
  }

  convertToTemplate(is_global: boolean = false) {
    if (this.form.invalid) {
      this.enableFormErrors = true;
      setTimeout(() => this.scrollToError(), 50);
    } else {
      this.enableFormErrors = false;
      this.loader.show('white', 'Saving');
      this.funnelStepService.convertToTemplate(this.stepId, is_global).subscribe(
        (_) => {
          this.loader.hide();
          this.showSaveMenu = false;
          this.alertService.success('Step converted to template successfully');
          this.navigateToTemplates();
        },
        (error) => {
          this.loader.hide();
          this.showSaveMenu = false;
          this.handleError(error);
        }
      );
    }
  }

  ngOnDestroy(): void {
    document.body.classList.remove('step-builder-active');
    this.sideNav.setSideNavExpanded(true);
    this.subscriptions.forEach((subscription) => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
    this.canDeactivateService.setFormDirty(false);
    this.stepEmulatorService.resetStepData();
  }

  isEligibleForDiscountWithRefund() {
    return [OfferIntents.CancelSubscriptionHold, OfferIntents.CancelRebillHold].includes(this.offerIntent);
  }

  get isReturnDownsell(): boolean {
    return !!this.funnel && this.funnel.offer_intent === OfferIntents.ReturnOrder;
  }

  get isOfferDetailsStep(): boolean {
    return this.isSingleStepOffer && this.stepType === CustomStepCategoryEnum.OfferDetails;
  }
}
